const CARD_RANK_LABEL_1 = "Best";
const CARD_RANK_LABEL_2 = "Worst";

const UNKNOWN_MSG = {
  type: "text",
  content: "Unknown message.",
  self: false,
};

const UNDO_MSG_CONTENT = "Undoing last response...";

const DELETE_MSG_CONTENT = "Deleting response...";
const AUTO_RESPONSE_MSG_CONTENT = "autoresponse";

const DONT_KNOW_MSG = "I don't know";

export const ThemeObjectLandscape = {
  main_color: "#49AE8A",
  secondary_color: "#fff",
  text_color: "#000000",
  error_color: "#F19C99",
  icon_image: "themes/shanna/shanna.jpeg",
  line_1: "Talking with",
  line_2: "Shanna Researcher",
  background_image: "themes/shanna/background.jpeg",
  redirect_message: "We'll send you back in {seconds} seconds",
  close_message: "You can close this window now.",
  disqualification_message:
    "We're sorry but you don't qualify for this survey today",
  orientation: "landscape",
  hints: {
    waiting: "Shanna Researcher is Typing...",
    multichoice: "Select your option...",
    multiselect: "Select your options...",
    others: "Enter your message...",
    multitext: "Enter your response...",
  },
  send_button: "Send",
  show_progress: false,
  show_grid_lines: false,
  transition_messages: [
    "Saving your response...",
    "Checking your response...",
    "Processing your answers...",
    "Selecting the next question...",
    "Loading the next question...",
  ],
};

export const ThemeObjectPotrait = {
  ...ThemeObjectLandscape,
  orientation: "potrait",
};

export {
  AUTO_RESPONSE_MSG_CONTENT,
  CARD_RANK_LABEL_1,
  CARD_RANK_LABEL_2,
  DELETE_MSG_CONTENT,
  DONT_KNOW_MSG,
  UNDO_MSG_CONTENT,
  UNKNOWN_MSG,
};

export const actionRequest = {
  type: "grid_rating",
  content: "What do you think about this phone benefits?",
  image: null,
  clickable: false,
  alt_text: null,
  dont_know_option: true,
  options: [
    {
      value: 1,
      text: "Love",
      disabled: false,
      display_text: false,
    },
    {
      value: 2,
      text: "Hate",
      disabled: true,
      display_text: false,
    },
    {
      value: 3,
      text: "Don't know",
      disabled: false,
      display_text: false,
      pop_up_text: "This is a pop up text",
    },
  ],
  rows: [
    {
      image: "test.jpg",
      value: "row1",
      text: "row1",
    },
  ],
  error_message: "Please reCheck that you selected correct option",
  chatbot:
    "Test question\n\nHere are the options to choose from:\n1. A\n2. B\n3. C\n\nPlease choose one option for each of the following:\n1. R\n2. o\n3. w\n\nRespond with the number of each option you want, separated by a tab.",
};

export const commonGlobalThemeTestObject = {
  globalObject: {
    themeData: {
      theme: ThemeObjectLandscape,
      normalizedTheme: defaultThemeV2,
    },
  },
};
import { defaultThemeV2 } from "../theme/defaultThemeV2";
